import React from 'react';
import "./index.css";
import Axios from 'axios';
import { Validator } from '../../client/Validator';
import ContextHelper from '../../client/ContextHelper';

export class SectionContactUs extends React.Component {
    state = {
        errorLabel: "",
        form: {
            name: "",
            email: "",
            phone: "",
            curriculum: "",
            description: "",
        },
        saving: false,
        sent: false
    }

    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getErrorText = this.getErrorText.bind(this);
    }

    getErrorText(formData){
        const {includeCurriculum, contactPage} = this.props;
        let validation;
        if(includeCurriculum){
            validation = Validator.validateCareersContact(formData);
        }else if(contactPage){
            validation = Validator.validateContactPageForm(formData);
        }else{
            validation = Validator.validateContactForm(formData);
        }

        if(validation){
            let fields = Object.keys(validation);
            if(     validation[fields[0]] 
                    && validation[fields[0]].length
                    && typeof validation[fields[0]][0] !== "function" 
                ){
                return validation[fields[0]].join(",");
            }
        }

        if(formData.email){
            const isValid = document.querySelector('input[name="email"]').checkValidity();
            if(!isValid){
                return "Invalid email provided.";
            }
        }else{
            return "Email is required";
        }
        
        return null;
    }


    handleSubmit = event => {
        event.preventDefault();
        if(this.state.saving){
            return;
        }

        const {includeCurriculum, contactPage} = this.props;
        
        var formData = new FormData();
        for(const key of Object.keys(this.state.form)){
            formData.append(key, this.state.form[key]);
        }
        const error = this.getErrorText(this.state.form);
        this.setState({
            errorLabel: error
        })
        if(error){
            return;
        }
        this.setState({saving: true});

        if(includeCurriculum){
            formData.set("curriculum", document.querySelector("form > fieldset > div > input[type='file']").files[0])
        }
        if(contactPage){
            formData.set('contactPage', true);
        }

        let host = this.props.api_host || "http://localhost:3000";
        
        if(window.location.port === "8000"){    //If developing
            host = "http://localhost:3000";
        }

        Axios({
            method: 'post',
            url: `${host}/up`,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data' }
        })
        .then((data)=>{
            console.log({data});
            setTimeout(()=>{
                this.setState({saving: false, sent: true});
            }, 5000);
        })
        .catch((err)=>{
            console.log({err});
            setTimeout(()=>{
                this.setState({saving: false, sent: false, errorLabel: "An error has occurred trying to contact us."});
            }, 5000);
        });
    }

    handleInputChange(event){
        const {name, value} = event.target;
        this.setState((prevState)=>{
            prevState.form[name] = value;
            return prevState;
        });
    }


    render(){
        const {includeCurriculum, contactPage} = this.props;
        const {errorLabel} = this.state;
        const {saving, sent} = this.state;

        
        return (
            <div className={`section-contact-us ${contactPage ? 'contact-page' : ''}`}>
                <div className="main-heading">
                    <h3>Contact Us</h3>
                </div>
                <div className='pure-g'>
                    <div className='pure-u-sm-1-1 pure-u-md-1-3'>
                    </div>
                    <div className='pure-u-sm-1-1 pure-u-md-1-3 form-container '>
                        <div className='email-us'>
                            <h4>Email us at
                            <br/>
                            <a href="mailto:peterantley@magyk.cloud" className='link'>peterantley@magyk.cloud</a>
                            <br/>
                            </h4>
                        </div>
                        
                        {
                            sent ? 
                            <div className="sent-message">
                                We received your request. We'll be back with you shortly...
                            </div> :
                            <>
                                <h4 className="alternative-text">Or write us here:</h4>
                                <form className="pure-form" method="post" encType="multipart/form-data" action="http://localhost:3000/up" onSubmit={this.handleSubmit}>
                                    <fieldset className="pure-group">
                                        {
                                            errorLabel ? 
                                            <div className="error-label">Error: <span>{errorLabel}</span></div>
                                            : <></>
                                        }
                                        {
                                            saving ? 
                                            <div className="loading-label">Sending...</div>
                                            : <></>
                                        }
                                        <input disabled={saving} onChange={this.handleInputChange} aria-label="Name" type="text" value={this.state.form.name} name="name" className="pure-input-1-1" placeholder="Your Name" />

                                        <input disabled={saving} onChange={this.handleInputChange} aria-label="Email" type="email" value={this.state.form.email} name="email" className="pure-input-1-1" placeholder="Email" />

                                        <input disabled={saving} onChange={this.handleInputChange} aria-label="Your Phone" type="text" value={this.state.form.phone} name="phone" className="pure-input-1-1 phone" placeholder="Your Phone" />
                                        {
                                            includeCurriculum ? 
                                            (
                                                <div className='curriculum-insert'>
                                                    <label htmlFor="phone">Your Curriculum (as .pdf):</label>
                                                    <input disabled={saving} onChange={this.handleInputChange} value={this.state.form.curriculum} name="curriculum" type="file" className='curriculum-upload pure-input-1-1' placeholder="Upload your file"/>
                                                </div>
                                            ) : <></>
                                        }
                                        <textarea disabled={saving} aria-label="Description" onChange={this.handleInputChange} value={this.state.form.description} name="description" className="pure-input-1-1" placeholder="What can we help you with?"></textarea>
                                    </fieldset>
                                    <button disabled={saving} type="submit" className="pure-button action-call-button">Contact Us</button>
                                </form>
                            </>
                        }
                    </div>
                    <div className='pure-u-sm-1-1 pure-u-md-1-3'>
                    </div>
                </div>
            </div>
        )
    }
}